import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Close, Search } from '../../assets/images';
import { getUserInfoForSearch } from '../../Helpers/Chat/User';
import { getValidSearchVal, handleFilterBlockedContact } from '../../Helpers/Utility';
import { REACT_APP_CONTACT_SYNC } from '../processENV';
import userList from './Common/userList';

class WebChatSearch extends React.Component {
    /**
     * Following the states used in WebChatSearch Component.
     *
     */
    constructor(props) {
        super(props);
        this.state = { isTyping: false };
        this.searchInputRef = React.createRef();
    }
    /**
     * Following the states used in WebChatSearch Component.
     *
     * @param {object} event to handle the searched element.
     */
    searchFilterList = () => {
        const value = this.searchInputRef.current?.value || '';
        const {
            searchIn,
            rosterDataResponse,
            rosterData: { data },
            handleSearchFilterList,
        } = this.props;
        const searchWith = getValidSearchVal(value);
        this.setState({
            isTyping: !!value,
        });
        if (!REACT_APP_CONTACT_SYNC) {
            handleSearchFilterList(null, searchWith);
            userList.getUsersListFromSDK(1, searchWith);
        } else {
            let updatedList = searchIn === 'recent-chat' ? rosterDataResponse : handleFilterBlockedContact(data);
            updatedList = updatedList
                .filter(item => item?.userId !== this.props?.vCardData?.data?.userId)
                .filter(item => {
                    const { roster, recent } = item;
                    let filterData = searchIn === 'recent-chat' ? roster || recent : item;
                    const regexList = getUserInfoForSearch(filterData);
                    return regexList.find(str => {
                        if (!item.isFriend || !str) return false;
                        return str.search(new RegExp(searchWith, 'i')) !== -1;
                    });
                });
            handleSearchFilterList(updatedList, value);
        }
    };

    /**
     * clear search field
     */
    clearSearch = () => {
        if (this.searchInputRef.current) {
            this.searchInputRef.current.value = '';
        }
        this.searchFilterList();
    };

    /**
     * render() method to render the WebChatSearch component into browser.
     */
    render() {
        const { isTyping } = this.state;
        return (
            <div className={`search-container ${isTyping ? 'typingValue' : ''}`}>
                <div className="search">
                    <i className={this.state.isTyping ? '' : 'Search'} title="Search">
                        {' '}
                        {!isTyping && <Search />}
                    </i>
                    <input
                        type="text"
                        ref={this.searchInputRef}
                        className="search-contacts"
                        name="search-contacts"
                        autoComplete="off"
                        placeholder="Search contact"
                        onChange={this.searchFilterList}
                    ></input>
                    <i
                        className={this.state.isTyping ? 'CloseSearch' : ''}
                        title="Clear search"
                        onClick={this.clearSearch}
                        onKeyDown={e => e.key === 'Enter' && this.clearSearch}
                        tabIndex="0"
                        role="button"
                    >
                        {isTyping && <Close />}
                    </i>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, _props) => {
    return {
        rosterData: state.rosterData,
        vCardData: state.vCardData,
    };
};

export default connect(mapStateToProps, null)(WebChatSearch);

WebChatSearch.propTypes = {
    searchIn: PropTypes.string,
    rosterDataResponse: PropTypes.array,
    rosterData: PropTypes.shape({
        data: PropTypes.array,
    }),
    handleSearchFilterList: PropTypes.func,
};
